<div class="card card-info d-flex flex-column mt-3 pb-4 mx-auto"
     style="width: 97%;border: 2px solid #bfbfbf;border-radius: 12px"
     [ngStyle]="{'margin-bottom': last ? '110px' : '1em'}"
     #contentBorderSelectTop>


  <!-- HEADER -->
  <div class="room-header"
       style="position: relative"
       [ngStyle]="{'padding': verifiedValidSelected(roomSelect) !== '' ? '30px 3.25em 70px  3.25em' : '35px 3.25em'}"
  >
    <div class="room-info">
      <p class="room-label">Tipo de habitación</p>
       <p class="room-type pr-5">{{ roomSelect.room.roomType | truncate: 30 : '...'}}</p>
    </div>

    <div class="d-flex align-items-end" style="gap:.75em;">
      <img *ngIf="verifiedValidSelected(roomSelect) !== ''"
           src="../../../../../assets/icons/search-result/hotel/ALERTA-24X24-01.svg"
           tooltip="{{verifiedValidSelected(roomSelect)}} {{verifiedOtherOptions(roomsSearch, roomBoardName, roomSelect)}}"
           placement="bottom"
           style="width: 24px;height: 24px; object-fit: contain;margin-bottom: 4px" alt="">
          <div class="room-selector">
          <p class="select-label">Seleccionar</p>
            <select
            id="selectRoom"
            #selectRoom
            class="form-control description-modal select-room-control"
            [disabled]="verifiedValidSelected(roomSelect) !== ''"
            (change)="onSelectionChange($event, roomSelect)">
            <option [disabled]="true" [selected]="true" [value]="null">Habitaciones</option>
              <option *ngFor="let room of roomValidSelected(roomsSearch); let i = index"
                      [value]="{ adults: room.qtyAdults, childs: room.qtyChilds, room: room } | json">
                <span> {{room.qtyAdults}} Adultos - {{room.qtyChilds}} Niños {{room.qtyChilds > 0 ? getChildrenAge(room) : ''}}</span>
              </option>
          </select>
      </div>
    </div>


    <div *ngIf="verifiedValidSelected(roomSelect) !== ''"
    class="d-flex justify-content-center px-5" style="position: absolute; bottom: 0; left:0;background-color: #fae7eb; width: 100%; padding: .25em 0;" >
    <p class="mb-0"  style="font-family: 'Poppins'; font-size: 14px;font-weight:500;color: #ed3b5b">
      {{verifiedValidSelected(roomSelect)}} {{verifiedOtherOptions(roomsSearch, roomBoardName, roomSelect)}}
  </div>

  </div>

  <!-- DETALLE DEL CUARTO -->
   <usb-room-detail
                    [detailRoomData]="detailRoomData"
                    [clientSetting]="clientSetting"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    (openPolitics)="openPolitics()"
   ></usb-room-detail>


  <!-- OTRAS OPCIONES -->
  <div class="room-options-container">
    <div class="room-options-wrapper">
      <p class="room-options-title">Opciones de habitación</p>

      <div class="room-options-list">
        <ng-container *ngFor="let r of roomBoardName; let i = index">
          <div class="room-option-item">

            <!-- Columna 1: Tipo de habitación -->
            <div class="room-option-type">
              <p class="room-option-name">{{ roomSelect.room.roomType }}</p>
              <p class="room-option-board">{{ r?.room?.boardName || 'Room Only' }}</p>
            </div>

            <!-- Columna 2: Política de cancelación -->
            <div class="room-option-cancellation">
              <p class="room-option-rate" [ngStyle]="{'color': r?.room?.rateClass === 'R' ? '#00d096' : '#B70D35'}">
                {{ r?.room?.rateClass === "R" ? 'Reembolsable' : 'No Reembolsable' }}
              </p>
         <p class="room-option-until">
            Hasta {{getCancellationPolicyFrom(r.room) === 'N/A' ? 'N/A' : (getCancellationPolicyFrom(r.room) | date : 'dd/MM/yyyy')}}</p>
            </div>

            <!-- Columna 3: Precio -->
            <div class="room-option-price">
              <p class="room-option-amount">
                {{ currencyAgency.code }} {{ r?.room?.netPriceProf
                      | currencyConverterPure: r?.room?.pricing?.currency: currencyAgency.code: currencies
                      | number: '1.2-2' }}
              </p>
              <p class="room-option-period">(Por Noche)</p>
            </div>




            <!-- Columna 4: Checkbox -->
            <div class="room-option-checkbox">
               <ng-container *ngIf="r?.room?.promotions && r?.room?.promotions?.promotionApplied && r?.room?.promotions?.promotionApplied.length > 0">
                  <ng-container *ngIf="r?.room?.promotions?.promotionApplied[0]?.currency">
                       <div class="d-flex flex-column pl-3 py-1"  style="border: 1px solid #ed3b5b; border-radius: 50rem;width: 100%;">
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 500;color: #ed3b5b; line-height: 1">Ahorras</p>
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 10px;font-weight: 500;color: #ed3b5b; line-height: 1">
                          {{r?.room?.promotions?.promotionApplied[0]?.currency ? currencyAgency?.code :''}}
                          {{r?.room?.promotions?.promotionApplied[0]?.discount_value  | currencyConverterPure:
                            r?.room?.pricing?.currency:
                            currencyAgency?.code:
                            currencies
                          | number: '1.2-2'}}
                          </p>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="!r?.room?.promotions?.promotionApplied[0]?.currency">
                      <div class="d-flex justify-content-center align-items-center"  style="border: 1px solid #ed3b5b; border-radius: 50rem;width: 100%;">
                        <p class="mb-0" style="font-family: 'Poppins', serif;font-size: 11px;font-weight: 500;color: #ed3b5b; margin-top: 2px">{{r?.room?.promotions?.promotionApplied[0]?.discount_value}}% Off</p>
                      </div>
                  </ng-container>
               </ng-container>

              <input type="checkbox"
                    class="black-checkbox"
                  [checked]="selectedOptionIndex === i"
                  (change)="selectOption($event, i, r)">
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- EXTRAS -->
  <div *ngIf="roomSelect?.room?.extras && roomSelect?.room?.extras.length > 0" class="mt-2 mb-4 room-extras" style="width: 100%">
    <usb-room-extras style="width: 100%"
                    [roomExtras]="roomSelect?.room?.extras"
                    [selectedRooms]="selectedRooms"
                    [currencyAgency]="currencyAgency"
                    [currencies]="currencies"
                    [buttonColorActive]="buttonColorActive"
                    [arrivalDate]="arrivalDate"
                    [extrasMap]="extrasMap"
                    (extrasChange)="onSelectionChangeExtras($event.action, $event.extra, $event.tabAddons)">
    </usb-room-extras>
  </div>


  <!-- CUARTOS SELECCIONADOS -->
<div class="selected-rooms-container" #containingDiv>
  <div class="selected-rooms-list" #selectedRoomsDiv>

    <p *ngIf="selectedRooms && selectedRooms.length > 0" class="room-options-title"
    style="margin-bottom: 12px;
           margin-top: 25px;
           margin-left: 8px;"
           >Habitaciones seleccionadas</p>

    <div *ngFor="let selectedRoom of selectedRooms; let i = index; trackBy: trackByRoomId" class="selected-room-item">

      <div class="selected-room-card" [class.height-additional]="getRoomExtras(selectedRoom)?.length > 0">

        <div class="room-info-wrapper">

          <div class="room-details" [class.has-extras]="getRoomExtras(selectedRoom)?.length > 0">
            <p class="room-title">
              {{ selectedRoom?.service?.boardName }} -
              <span class="room-rate" [class.refundable]="selectedRoom?.service?.rateClass === 'R'"
                                   [class.non-refundable]="selectedRoom?.service?.rateClass !== 'R'">
                {{ getNameRateClass(selectedRoom?.service?.rateClass) }}
              </span> -
              <span class="room-occupancy">
                {{ selectedRoom.room.qtyAdults }} Adultos, {{ selectedRoom.room.qtyChilds }} Niños {{selectedRoom.room.qtyChilds > 0 ? getChildrenAge(selectedRoom.room) : ''}}
              </span>
              - {{ currencyAgency.code }} {{ getFinalPrice(selectedRoom) | number: '1.2-2' }}
            </p>
          </div>

          <div *ngIf="getRoomExtras(selectedRoom)?.length > 0" class="room-extras-list">
            <div *ngFor="let extra of getRoomExtras(selectedRoom); let i = index; let last = last" class="extras-wrapper" [class.extras-wrapper-border]="!last">
              <img [src]="getExtraIcon(extra)" class="extras-icon"
                    [alt]="getExtraType(extra)">
              <p class="extras-text">{{ extra.title || extra.name }}</p>
            </div>
          </div>

        </div>

        <div class="btn-delete-room"
             (click)="offSelectionRooms(roomSelect, i, selectedRoom)"
             tooltip="Eliminar habitación"
             placement="bottom">
                    <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                      style="fill: #ff3f63; width: 25px;" xml:space="preserve">
                      <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                        c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                        c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                        c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                        c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                      <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C153.6,439.4,161.3,447,170.7,447z"/>
                      <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                        "/>
                      <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C324.3,439.4,331.9,447,341.3,447z"/>
                    </svg>
        </div>


        <!-- <button class="btn-delete-room"
                (click)="offSelectionRooms(roomSelect, i, selectedRoom)"
                tooltip="Eliminar habitación"
                placement="bottom">
          <img class="delete-icon"
              width="20"
              alt="Eliminar"
              src="../../../../../assets/icons/cart/eliminar.svg" />
        </button> -->


      </div>
    </div>
  </div>
</div>

  <usb-accordion-info-product
    #accordionComponent
    [items]="accordionItems"
    [config]="accordionConfig"
    [categoryId]="1"
    (itemToggle)="onAccordionToggle($event)">

    <ng-template #accordionContent let-item let-index="index">
      <ng-container [ngSwitch]="item.id">

        <!-- Descripción -->
        <div *ngSwitchCase="'description'">
          <p class="mb-0 text-description-accordion"
          [innerHTML]="item.data.description"
          *ngIf="item.data.description; else noDesc">
          </p>
          <ng-template #noDesc>
            <p class="text-muted">No hay información disponible</p>
          </ng-template>
        </div>

        <!-- Políticas de Cancelación -->
        <div *ngSwitchCase="'policies'">
          <usb-cancellation-policies
            class="accordion-item-policies"
            #politicsSection
            [cancellationPolicies]="cancellationPolicies"
            [currencies]="currencies"
            [currencyAgency]="currencyAgency"
            [categoryId]="1">
          </usb-cancellation-policies>
        </div>

      </ng-container>
    </ng-template>

  </usb-accordion-info-product>

</div>
